<template>
  <div>
    <Row style="padding-bottom: 5px" justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="500px"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
          </Row>
        </div>
        <div class="wid_img">
          <div>
            <img :src="item01.photoUrl1" alt="暂无图片" />
          </div>
          <div class="Introduction">
            <div class="phone">
              咨询电话: <span style="color: #1966ff"> 18001306738</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      photoArr1: [
        {
          photoUrl: "../../../static/img/case/erju.png",
          photoUrl1: "../../../static/img/case/erju1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
        {
          photoUrl: "../../../static/img/case/yiyuan.png",
          photoUrl1: "../../../static/img/case/yiyuan1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
        {
          photoUrl: "../../../static/img/case/shixun.png",
          photoUrl1: "../../../static/img/case/shixun1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
        {
          photoUrl: "../../../static/img/case/xiaofangdadui.png",
          photoUrl1: "../../../static/img/case/xiaofangdadui1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
        {
          photoUrl: "../../../static/img/case/xiaofangzhongdui.png",
          photoUrl1: "../../../static/img/case/xiaofangzhongdui1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
        {
          photoUrl: "../../../static/img/case/puyang.png",
          photoUrl1: "../../../static/img/case/puyang1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
        {
          photoUrl: "../../../static/img/case/sanju.png",
          photoUrl1: "../../../static/img/case/sanju1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
        {
          photoUrl: "../../../static/img/case/aiqing.png",
          photoUrl1: "../../../static/img/case/aiqing1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
        {
          photoUrl: "../../../static/img/case/huji.png",
          photoUrl1: "../../../static/img/case/huji1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
        {
          photoUrl: "../../../static/img/case/yiye.png",
          photoUrl1: "../../../static/img/case/yiye1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
        {
          photoUrl: "../../../static/img/case/yiyuan.png",
          photoUrl1: "../../../static/img/case/yiyuan1.png",
          // p: "",
          // ref: "透明屏液晶展柜",
          // money: "￥30000.00",
        },
      ],
    };
  },
  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*弹出框字体*/
.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  align-items: center;
}

.wid_img img {
  width: 470px;
}

.Introduction {
  margin-left: 15px;
}

.Introduction__p {
  margin-top: 15px;
}

.buy_rule img:hover {
  animation: move 0.5s linear forwards;
}

@keyframes move {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}

.phone {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/ThreeDimensional.vue